import { DiscordSDK, patchUrlMappings, Platform as DiscordPlatform } from '@discord/embedded-app-sdk';
import { Platform } from '../types/platform';
import { PlatformApi } from '../types/platform-api';
import { PlatformConfig } from '../types/platform-config';

export class DiscordActivityPlatformApi implements PlatformApi {
  platform = Platform.DiscordActivity;
  isMobile: boolean;
  discordClientId: string;
  discordSdk: DiscordSDK;
  discordProxyUrl: string;

  constructor(private defs: PlatformConfig) {
    this.discordClientId = defs.discordClientId!;
    this.discordSdk = new DiscordSDK(this.discordClientId);
    this.discordProxyUrl = defs.discordProxyUrl!;
    // discordSdk.platform is parsed by the SDK constructor from the platform
    // param Discord injects; no need to await discordSdk.ready() to read it.
    this.isMobile = this.discordSdk.platform === DiscordPlatform.MOBILE;
  }

  initialize(): void {
    if (this.defs.discordPatchUrlMappings) {
      patchUrlMappings(this.defs.discordPatchUrlMappings);
    }
  }
}
